<template>
  <div class="leads-to-no-recommendation-message">
    <div class="leads-to-no-recommendation-message__icon">
      <info-icon />
    </div>
    <div class="leads-to-no-recommendation-message__text">
      {{ $t('recommender.answerOptionLeadsToNoRecommendation') }}
    </div>
  </div>
</template>

<script>
// @flow

import InfoIcon from '../Icons/InfoIcon.vue'

export default {
  components: {
    InfoIcon
  }
}
</script>

<style src="./leads-to-no-recommendation-message.scss" />
